<div class="card flex flex-column gap-3">

    <!-- Loading State -->
    <div *ngIf="loading" class="w-full flex align-items-center justify-content-center py-6 widget-text-color gap-2">
        <i class="pi pi-spin pi-spinner text-xl"></i>
        <span>{{ translateServ.dictionary['LOADING_JOURNAL_MOVES'] }}</span>
    </div>

    <!-- Error State -->
    <div *ngIf="!loading && error"
        class="w-full p-3 border-round bg-red-50 text-red-600 text-sm flex align-items-center gap-2">
        <i class="pi pi-exclamation-circle text-base"></i>
        <span>{{ error }}</span>
    </div>

    <!-- Enhanced Empty State -->
    <div *ngIf="!loading && !error && totalRows === 0" class="flex flex-column gap-3"
        [ngClass]="isRtl ? 'align-items-end text-right' : 'align-items-start text-left'">
        <div class="font-semibold text-xl widget-text-color">{{ translateServ.dictionary['TIT_ACT_JOR'] }}</div>

        <div
            class="w-full flex flex-column align-items-center justify-content-center py-6 px-3 text-center border-round border-1 border-dashed surface-border surface-ground">
            <div
                class="w-3rem h-3rem flex align-items-center justify-content-center border-circle surface-card mb-3 shadow-1">
                <i class="pi pi-book text-xl text-surface-400"></i>
            </div>
            <div class="font-medium text-surface-800 text-base mb-1">{{ translateServ.dictionary['NO_ACT_JOR'] }}.</div>
            <p class="widget-text-color text-xs m-0 max-w-16rem line-height-3">
                {{ translateServ.dictionary['NO_ACT_JOR_EXP'] }}.
            </p>
        </div>
    </div>

    <!-- Active Chart Layout -->
    <div *ngIf="!loading && !error && totalRows > 0" class="w-full flex align-items-center justify-content-center gap-4"
        [ngClass]="isRtl ? 'flex-row' : 'flex-row'">

        <!-- TEXT COLUMN (Title + Subtitle) -->
        <div class="flex flex-column gap-2" style="display: flex !important; flex-direction: column !important; flex: 0 1 auto; min-width: 0;"
            [ngClass]="isRtl ? 'align-items-end text-right' : 'align-items-start text-left'">

            <div class="font-semibold text-xl white-space-nowrap overflow-hidden text-overflow-ellipsis widget-text-color" style="max-width: 100%;">
                {{ translateServ.dictionary['TIT_ACT_JOR'] }}  - {{ viewScopeService.getCurrentCustomerName() }}
            </div>

            <div class="widget-text-color text-sm" style="max-width: 16rem; line-height: 1.4;">
                {{ translateServ.dictionary['TIT_ACT_JOR_EXP'] }}
            </div>
        </div>

        <!-- CHART COLUMN -->
        <div style="height: 16rem; width: 22rem; flex-shrink: 0;">
            <p-chart type="doughnut" [data]="chartData" [options]="chartOptions" [plugins]="chartPlugins"
                class="w-full h-full block">
            </p-chart>
        </div>
    </div>
</div>